import { app_version } from "@/config";

const getWebApp = () => {
  if (typeof window !== "undefined" && (window as any).Telegram?.WebApp) {
    return (window as any).Telegram.WebApp;
  }
  return null;
};

export class LSService {
  private static readonly tonAuthTokenKey = "tonAuthKey";
  private static readonly authVersionKey = "authVersionKey";
  private static readonly TOKEN_EXPIRY_DAYS = 30;
  private static WebApp = (window as any).Telegram?.WebApp;
  private static cloudStorage = this.WebApp?.CloudStorage;

  private static isCloudAvailable(): boolean {
    const webApp = getWebApp();
    // not smaller 6.9
    const isTrueVersion = !!(webApp?.CloudStorage && webApp.isVersionAtLeast?.("6.9"));
    if (!isTrueVersion) {
      console.log("Version not true, current:", webApp.Version)
    }
    return isTrueVersion;
  }

  private static async getCloudItem(key: string): Promise<string | null> {
    const webApp = getWebApp();
    if (!this.isCloudAvailable()) return null;

    return new Promise(resolve => {
      webApp.CloudStorage.getItem(key, (err: any, value: string) => {
        if (err) resolve(null);
        else resolve(value || null);
      });
    });
  }

  private static async setCloudItem(key: string, value: string): Promise<void> {
    const webApp = getWebApp();
    if (!this.isCloudAvailable()) return;

    return new Promise(resolve => {
      webApp.CloudStorage.setItem(key, value, () => resolve());
    });
  }
  // Cookie helpers for iOS persistence
  private static setCookie(name: string, value: string, days: number) {
    try {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax;Secure`;
    } catch (e) {
      console.warn("Failed to set cookie:", e);
    }
  }

  private static getCookie(name: string): string | null {
    try {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return c.substring(nameEQ.length, c.length);
      }
    } catch (e) {
      console.warn("Failed to get cookie:", e);
    }
    return null;
  }

  public static async setTonAuthToken(token: string) {
    // 1. LocalStorage
    try {
      localStorage.setItem(this.tonAuthTokenKey, token);
    } catch (e) {}

    // 2. Cookie
    this.setCookie(this.tonAuthTokenKey, token, this.TOKEN_EXPIRY_DAYS);

    // 3. CloudStorage (Telegram)
    await this.setCloudItem(this.tonAuthTokenKey, token);

    console.log("✅ Token synced across all storages");
  }

  public static async getTonAuthToken(): Promise<string | null> {
    // Порядок проверки: LS -> Cloud -> Cookie

    // 1. Пробуем LocalStorage
    let token = localStorage.getItem(this.tonAuthTokenKey);
    if (token) return token;

    // 2. Пробуем CloudStorage (самый надежный)
    token = await this.getCloudItem(this.tonAuthTokenKey);
    if (token) {
      console.log("☁️ Token recovered from CloudStorage");
      // Восстанавливаем в LS для быстрого доступа в будущем
      localStorage.setItem(this.tonAuthTokenKey, token);
      return token;
    }

    // 3. Пробуем Cookie
    token = this.getCookie(this.tonAuthTokenKey);
    if (token) {
      console.log("🍪 Token recovered from Cookie");
      localStorage.setItem(this.tonAuthTokenKey, token);
      return token;
    }

    return null;
  }

  public static async updateAuthVersion() {
    localStorage.setItem(this.authVersionKey, app_version);
    this.setCookie(this.authVersionKey, app_version, this.TOKEN_EXPIRY_DAYS);
    await this.setCloudItem(this.authVersionKey, app_version);
  }

  public static async deleteTonAuthToken() {
    localStorage.removeItem(this.tonAuthTokenKey);
    this.deleteCookie(this.tonAuthTokenKey);
    return new Promise(resolve => {
      if (!this.cloudStorage) return resolve(true);
      this.cloudStorage.removeItem(this.tonAuthTokenKey, () => resolve(true));
    });
  }

  private static deleteCookie(name: string) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }
}
